export default {
    name: 'Application',
    version: '1.2.20',
    appId: '5c65b129-1ed3-4503-983f-3902bfa6e7c6',
    securityKey: "D8PtfV1Lx1B3m9Yf2HdXjRIiMGIfOXik",
    publicKey: `-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGshBkAuqwQnGnCFNRRerFMKkdpfQEZ9zmoMWnS65rC23Kw1LuKOLTMnX2jhb9K4nDT2uN+VJDC2GsGJOh8DSCT7L51GwEpSy9wCI1kVz5asL1NgKpDJyTE4ilNg5dMsk2AV/+9TedR2QM4xm2jkYRnsMv+toBvv5oWS6EqHIhqQIDAQAB-----END PUBLIC KEY-----`,
}
